export enum ExperimentSpec {
  FullStory = 'specs.media-manager-g6.FullStory',
  // internal to find wix employees
  PublicMediaWixOnly = 'specs.media-manager-g6.PublicMediaWixOnly',
  CantBuyOnShutterstock = 'specs.media-manager-g6.CantBuyOnShutterstock',
  // for editor media panel
  NewCheckout = 'specs.media-manager-g6.NewCheckout',
  NTT = 'specs.media-manager-g6.internal.NTT',
  ShowKeys = 'specs.media-manager-g6.internal.ShowKeys',
  OnlyFavsBoard = 'specs.media-manager-g6.internal.OnlyFavsBoard',
  PreventFontsUpload = 'specs.media-manager-g6.PreventFontsUploads',
  ForceUploadErrors = 'specs.media-manager-g6.internal.ForceUploadErrors',
  // when true dealer Lightbox wont pop up open just for specific user guides. made for automation/QA purpose only
  ExcludeDealerLightbox = 'specs.dealerClient.ExcludeDealerLightbox',
  DisableUpload = 'specs.media-manager-g6.DisableUpload',
  SemanticSearch = 'specs.media-manager-g6.SemanticSearch',
  LinkToPublicCMS = 'specs.media-manager-g6.LinkToPublicCMS',
  PriceWithTax = 'specs.media-manager-g6.PriceWithTax',
  HideShareFromAgencies = 'specs.media-manager-g6.HideShareFromAgencies',
  Yell = 'specs.media-manager-g6.Yell',
  ForceYell = 'specs.media-manager-g6.ForceYell',
  WSRNewColorsBranding = 'specs.media-manager-g6.NewColorsBranding',
  UploadUpgradeLink = 'specs.media-manager-g6.UploadUpgradeLink',
  StorageQuotaVisibilityAndEnforcement = 'specs.media-manager-g6.StorageQuotaVisibilityAndEnforcement',
  ManageStorageButton = 'specs.media-manager-g6.ManageStorageButton',
  AiTextToImage = 'specs.mdst.AiTextToImage',
}
